(function () {
  if (window.ersQuickViewInitialized) return;
  window.ersQuickViewInitialized = true;

  var cache = new Map();
  var activeRequest = null;
  var requestNumber = 0;
  var returnFocus = null;
  var previousBodyOverflow = '';
  var previousBodyPaddingRight = '';
  var desktopQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var galleryPlayers = [];

  function pauseGallery(destroy) {
    galleryPlayers.forEach(function (entry) {
      entry.playRequested = false;
      if (entry.ready) entry.player.pauseVideo();
      if (destroy) {
        entry.disposed = true;
        if (entry.player) entry.player.destroy();
      }
    });
    if (destroy) galleryPlayers = [];
  }

  function initializeGallery(root) {
    root.querySelectorAll('.quick-view-youtube-video').forEach(function (iframe) {
      var url = new URL(iframe.src);
      if (url.searchParams.get('origin') !== window.location.origin) {
        url.searchParams.set('origin', window.location.origin);
        iframe.src = url.toString();
      }
      var entry = { wrapper: iframe.closest('[data-quick-view-video]'), ready: false, playRequested: false, disposed: false };
      galleryPlayers.push(entry);
      function active() {
        return !entry.disposed && root.isConnected && isOpen() && !entry.wrapper.hidden;
      }
      window.theme.loadYouTubeApi().then(function () {
        if (entry.disposed) return;
        entry.player = new YT.Player(iframe, { events: {
          onReady: function (event) {
            entry.ready = true;
            if (entry.playRequested && active()) event.target.playVideo();
          },
          onStateChange: function (event) {
            if (event.data === YT.PlayerState.PLAYING && !active()) event.target.pauseVideo();
          }
        } });
      }).catch(function () {
        // Keep native iframe controls usable if the API cannot load.
      });
    });
  }

  function elements() {
    var root = document.querySelector('[data-quick-view]');
    return root ? {
      root: root,
      backdrop: root.querySelector('[data-quick-view-backdrop]'),
      dialog: root.querySelector('[data-quick-view-dialog]'),
      content: root.querySelector('[data-quick-view-content]'),
      status: root.querySelector('[data-quick-view-status]'),
      close: root.querySelector('[data-quick-view-close]')
    } : null;
  }

  function isOpen() {
    var ui = elements();
    return Boolean(ui && !ui.root.hidden);
  }

  function isCartDrawerOpen() {
    return Boolean(document.querySelector('#ajaxifyDrawer.is-visible'));
  }

  function lockScroll() {
    previousBodyOverflow = document.body.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('quick-view-scroll-lock');
  }

  function unlockScroll() {
    document.body.classList.remove('quick-view-scroll-lock');
    document.body.style.overflow = previousBodyOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
  }

  function loadingMarkup() {
    return '<div class="quick-view__loading" aria-hidden="true">' +
      '<div class="quick-view__loading-block"></div>' +
      '<div class="quick-view__loading-block"></div>' +
      '</div>';
  }

  function showModal(trigger) {
    var ui = elements();
    if (!ui) return null;

    returnFocus = trigger;
    if (ui.root.hidden) {
      ui.root.hidden = false;
      lockScroll();
      window.requestAnimationFrame(function () { ui.root.classList.add('is-open'); });
    }
    ui.close.focus({ preventScroll: true });
    return ui;
  }

  function closeModal(suppressPointerReturn) {
    var ui = elements();
    if (!ui || ui.root.hidden) return;

    pauseGallery(false);
    ui.content.querySelectorAll('[data-quick-view-video] iframe:not(.quick-view-youtube-video)').forEach(function (iframe) {
      iframe.src = iframe.src;
    });

    requestNumber += 1;
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }

    ui.root.classList.remove('is-open');
    ui.root.hidden = true;
    ui.content.removeAttribute('aria-busy');
    ui.status.textContent = '';
    unlockScroll();

    var focusTarget = returnFocus;
    returnFocus = null;
    if (focusTarget && document.documentElement.contains(focusTarget)) {
      focusTarget.classList.toggle('is-quick-view-pointer-return', Boolean(suppressPointerReturn));
      focusTarget.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('quick-view:closed', {
      detail: {
        returnFocusElement: focusTarget,
        pointerReturn: Boolean(suppressPointerReturn)
      }
    }));
  }

  function productRequestUrl(productUrl) {
    var url = new URL(productUrl, window.location.href);
    url.searchParams.set('view', 'quick-view');
    return url;
  }

  function renderProduct(ui, html) {
    ui.content.innerHTML = html;
    ui.content.removeAttribute('aria-busy');
    ui.status.textContent = '';
    initializeProduct(ui.content);
  }

  function renderError(ui, productUrl) {
    var safeUrl = new URL(productUrl, window.location.href).href;
    ui.content.innerHTML = '<div class="quick-view__error">' +
      '<h2 id="QuickViewTitle">Quick View unavailable</h2>' +
      '<p>We couldn\u2019t load this product right now.</p>' +
      '<a class="btn" href="' + safeUrl.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '">View Full Details</a>' +
      '</div>';
    ui.content.removeAttribute('aria-busy');
    ui.status.textContent = 'Quick View could not be loaded.';
  }

  function openProduct(trigger) {
    if (!desktopQuery.matches) return;

    var productUrl = trigger.getAttribute('data-product-url');
    if (!productUrl) return;

    var ui = showModal(trigger);
    if (!ui) return;

    // Cached HTML is rendered afresh on each open; release the old players first.
    pauseGallery(true);

    var requestUrl = productRequestUrl(productUrl);
    var cacheKey = requestUrl.pathname;
    var currentRequestNumber = ++requestNumber;

    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }

    if (cache.has(cacheKey)) {
      renderProduct(ui, cache.get(cacheKey));
      return;
    }

    ui.content.setAttribute('aria-busy', 'true');
    ui.content.innerHTML = loadingMarkup();
    ui.status.textContent = 'Loading Quick View\u2026';

    activeRequest = new AbortController();
    var controller = activeRequest;

    fetch(requestUrl.href, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' },
      signal: controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Quick View request failed');
        return response.text();
      })
      .then(function (html) {
        if (currentRequestNumber !== requestNumber || !isOpen()) return;
        if (!html || html.indexOf('data-quick-view-product') === -1) throw new Error('Quick View response was invalid');
        cache.set(cacheKey, html);
        activeRequest = null;
        renderProduct(ui, html);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (currentRequestNumber !== requestNumber || !isOpen()) return;
        activeRequest = null;
        renderError(ui, productUrl);
      });
  }

  function variantData(root) {
    var script = root.querySelector('[data-quick-view-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function selectImage(root, imageId, imageSrc, imageAlt) {
    var image = root.querySelector('[data-quick-view-main-image]');
    var video = root.querySelector('[data-quick-view-video="' + imageId + '"]');
    if (!video && (!image || !imageSrc)) return;

    if (image) {
      image.hidden = Boolean(video);
      if (!video) {
        image.src = imageSrc;
        if (imageAlt) image.alt = imageAlt;
      }
    }
    root.querySelectorAll('[data-quick-view-video]').forEach(function (wrapper) {
      if (!wrapper.hidden && wrapper !== video) {
        var fallback = wrapper.querySelector('iframe:not(.quick-view-youtube-video)');
        if (fallback) fallback.src = fallback.src;
      }
      wrapper.hidden = wrapper !== video;
    });
    galleryPlayers.forEach(function (entry) {
      entry.playRequested = entry.wrapper === video;
      if (!entry.ready) return;
      if (entry.playRequested) entry.player.playVideo();
      else entry.player.pauseVideo();
    });
    root.querySelectorAll('[data-quick-view-thumb]').forEach(function (thumb) {
      var active = String(thumb.getAttribute('data-image-id')) === String(imageId);
      thumb.classList.toggle('is-active', active);
      if (active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  function updateVariant(root, id) {
    var variants = variantData(root);
    var variant = variants.find(function (item) { return String(item.id) === String(id); });
    if (!variant) return;

    var form = root.querySelector('[data-custom-add-to-cart-box]');
    var sku = root.querySelector('[data-quick-view-sku]');
    var price = root.querySelector('[data-quick-view-price]');
    var stock = root.querySelector('[data-quick-view-stock]');
    var button = root.querySelector('[data-custom-add-to-cart-button]');
    var buttonLabel = button && button.querySelector('[id^="addToCartText-"]');

    if (form) form.setAttribute('data-variant-id', variant.id);
    if (price) price.textContent = variant.priceFormatted;
    if (sku) {
      sku.textContent = variant.sku || '';
      sku.hidden = !variant.sku;
    }

    if (stock) {
      stock.classList.remove('is-low-stock', 'is-sold-out');
      if (!variant.available) {
        stock.textContent = 'Sold Out';
        stock.classList.add('is-sold-out');
      } else if (variant.inventoryManagement && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 10) {
        stock.textContent = 'Low Stock \u2014 ' + variant.inventoryQuantity + ' available';
        stock.classList.add('is-low-stock');
      } else {
        stock.textContent = 'In Stock';
      }
    }

    if (button) {
      button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? button.getAttribute('data-idle-label') : 'Sold Out';
    }

    if (variant.imageSrc) selectImage(root, variant.imageId, variant.imageSrc, variant.imageAlt);
  }

  function initializeProduct(container) {
    var root = container.querySelector('[data-quick-view-product]');
    if (!root) return;
    initializeGallery(root);
    var select = root.querySelector('[data-quick-view-variant]');
    if (select) updateVariant(root, select.value);
  }

  function focusableElements(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) { return !element.hidden && element.offsetParent !== null; }
    );
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      trigger.classList.remove('is-quick-view-pointer-return');
      openProduct(trigger);
      return;
    }

    if (event.target.closest('[data-quick-view-close]')) {
      event.preventDefault();
      closeModal(event.detail !== 0);
      return;
    }

    var ui = elements();
    if (ui && event.target === ui.backdrop) {
      closeModal(true);
      return;
    }

    var thumb = event.target.closest('[data-quick-view-thumb]');
    if (thumb && ui && ui.root.contains(thumb)) {
      event.preventDefault();
      selectImage(
        thumb.closest('[data-quick-view-product]'),
        thumb.getAttribute('data-image-id'),
        thumb.getAttribute('data-image-src'),
        thumb.getAttribute('data-image-alt')
      );
    }
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-quick-view-variant]');
    if (!select) return;
    updateVariant(select.closest('[data-quick-view-product]'), select.value);
  });

  document.addEventListener('keydown', function (event) {
    var returnedTrigger = event.target.closest && event.target.closest('[data-quick-view-trigger].is-quick-view-pointer-return');
    if (returnedTrigger) returnedTrigger.classList.remove('is-quick-view-pointer-return');

    if (!isOpen()) return;
    if (isCartDrawerOpen()) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeModal(false);
      return;
    }

    if (event.key !== 'Tab') return;
    var ui = elements();
    if (!ui) return;
    var focusable = focusableElements(ui.dialog);
    if (!focusable.length) {
      event.preventDefault();
      ui.dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (!isOpen()) return;
    if (isCartDrawerOpen()) return;
    if (event.target.closest('[data-cart-toast]')) return;
    var ui = elements();
    if (!ui || ui.dialog.contains(event.target)) return;
    var focusable = focusableElements(ui.dialog);
    (focusable[0] || ui.dialog).focus({ preventScroll: true });
  });

  document.addEventListener('pointerover', function (event) {
    var media = event.target.closest && event.target.closest('.quick-view-card-media');
    if (!media) return;
    var trigger = media.querySelector('[data-quick-view-trigger].is-quick-view-pointer-return');
    if (trigger) trigger.classList.remove('is-quick-view-pointer-return');
  });

  document.addEventListener('shopify:section:unload', function () {
    if (isOpen() && returnFocus && !document.documentElement.contains(returnFocus)) closeModal(true);
  });
})();
